module.exports = __webpack_public_path__ + "img/58.95274882.jpg";